import { render, staticRenderFns } from "./PrincipalIngresosPage.vue?vue&type=template&id=b6c0c5ee"
import script from "./PrincipalIngresosPage.js?vue&type=script&lang=js&external"
export * from "./PrincipalIngresosPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports